// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Anmol Rajpal <anmol@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

// Small helpers shared across the intake layer.

// Temporarily disabled — patient-safety emergency intercept; flip to true to re-enable.
// While false, every /emergency auto-redirect (client keyword match, backend "emergency"
// status, and emergencyFlagged) is skipped and intake keeps going; the /emergency route +
// screen stay mounted. All gating lives at the call sites in use-intake-conversation.ts.
export const EMERGENCY_INTERCEPT_ENABLED = false

/** Opaque client-side id for optimistic/local messages (not the server sequence number). */
export function newMessageId(): string {
  return crypto.randomUUID()
}

/** Human-formatted local time for message display (e.g. "1:41 PM"). Not persisted. */
export function formatTime(date: Date = new Date()): string {
  return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
}

// Keyword list is a client-side SAFETY NET only. The backend/ai-gateway red-flag
// interceptor is authoritative (surfaced as conversation status "emergency"); this lets
// the UI react instantly and gives the dev flow (no backend) a way to reach /emergency.
const EMERGENCY_KEYWORDS = [
  'chest pain', "can't breathe", 'cannot breathe', 'difficulty breathing',
  'heart attack', 'stroke', 'call 911', '911', 'unconscious',
  'not breathing', 'severe bleeding', 'overdose', 'poisoning',
  'suicidal', 'suicide', 'kill myself', 'hurt myself',
]

// Pure keyword match. Callers gate on EMERGENCY_INTERCEPT_ENABLED, so while the intercept
// is disabled this is never consulted; keeping it pure keeps the keyword list under test.
export function containsEmergency(text: string): boolean {
  const lower = text.toLowerCase()
  return EMERGENCY_KEYWORDS.some((kw) => lower.includes(kw))
}
